import {Injectable} from '@angular/core';
import {SessionStorageService} from './session-storage.service';
import {defaultThemeDescriptions, ThemeDescription} from '../models/theme-description';
import { PrimeNG } from 'primeng/config';
import * as OldThemes from '../themes/old-themes';
import { usePreset } from '@primeuix/themes';

@Injectable({
    providedIn: 'root'
})
export class UserSettingsService {

    constructor(private storage: SessionStorageService, private primeng: PrimeNG) {
    }

    public setTheme(themeId: number) {
        const theme = this.getThemeById(themeId);
        this.storage.storeSelectedTheme(theme.id);
        this.applyTheme(theme);
    }

    public getTheme(): ThemeDescription {
        const themeId = this.storage.getSelectedTheme();
        console.log(`Loaded theme id from storage: ${themeId}`);
        if (!themeId) {
            console.log('Using default theme id: 2');
        }
        return this.getThemeById(themeId ?? 2);
    }

    public applyTheme(theme: ThemeDescription) {
        const html = document.querySelector('html');
        const body = document.querySelector('body');
        html.classList.remove('dark');
        html.classList.remove('light');
        body.classList.remove('dark');
        body.classList.remove('light');

        let preset: any;
        switch (theme.cssFilename) {
            case 'saga-blue': preset = OldThemes.SagaBlue; break;
            case 'vela-blue': preset = OldThemes.VelaBlue; break;
            case 'saga-green': preset = OldThemes.SagaGreen; break;
            case 'vela-green': preset = OldThemes.VelaGreen; break;
            case 'saga-orange': preset = OldThemes.SagaOrange; break;
            case 'vela-orange': preset = OldThemes.VelaOrange; break;
            case 'saga-purple': preset = OldThemes.SagaPurple; break;
            case 'vela-purple': preset = OldThemes.VelaPurple; break;
            default: preset = OldThemes.SagaBlue;
        }

        usePreset(preset);

        if (theme.darkTheme) {
            html.classList.add('dark');
            body.classList.add('dark');
        } else {
            html.classList.add('light');
            body.classList.add('light');
        }
    }

    private getThemeById(themeId: number) {
        if (themeId == null) {
            return defaultThemeDescriptions[0];
        }
        return defaultThemeDescriptions.find(theme => theme.id === themeId) ?? defaultThemeDescriptions[0];
    }


}

